import React from 'react';
import { motion } from 'framer-motion';
type PageHeroProps = {
  title: string;
  eyebrow?: string;
  subtitle?: string;
  note?: string;
  image: string;
  icon?: React.ReactNode;
  /** Word inside the title to render in the rose→violet gradient. */
  accent?: string;
};
export function PageHero({
  title,
  eyebrow,
  subtitle,
  note,
  image,
  icon,
  accent
}: PageHeroProps) {
  const [before, after] = accent ? title.split(accent) : [title, ''];
  return <section className="relative w-full overflow-hidden" data-id="element-88" data-mp="pvfs81cvfwxc">
      <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" data-id="element-89" data-mp="uqv4iov8dkrn" />
      <div className="absolute inset-0 bg-gradient-to-b from-ink-950/85 via-ink-950/55 to-ink-950" data-id="element-90" data-mp="g1fpg652b3rs" />
      <div className="absolute inset-0 mix-blend-soft-light" style={{
      backgroundImage: 'radial-gradient(60% 60% at 15% 20%, rgba(232,54,127,0.5) 0%, rgba(232,54,127,0) 65%), radial-gradient(60% 60% at 85% 25%, rgba(168,85,247,0.45) 0%, rgba(168,85,247,0) 65%)'
    }} data-id="element-91" data-mp="l00klr5gix9d" />
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1]
    }} className="relative mx-auto flex w-full max-w-3xl flex-col items-center px-5 py-28 text-center sm:px-8 sm:py-32" data-id="element-92" data-mp="2xjh9i8y1l3qe">
        {icon && <span className="mb-8 flex h-14 w-14 items-center justify-center rounded-full border border-lotus-500/50 bg-lotus-500/10 text-lotus-300" data-id="element-93" data-mp="3l80mh1s1e4ot">
            {icon}
          </span>}
        {eyebrow && <p className="text-[11px] font-medium uppercase tracking-[0.4em] text-lotus-400" data-id="element-94" data-mp="3v5oh7rpn7c6z">
            {eyebrow}
          </p>}
        <h1 className="text-shadow-soft mt-5 font-display text-5xl font-light tracking-wide text-white sm:text-6xl" data-id="element-95" data-mp="3q5ttfx15z2q5">
          {accent ? <>
              {before}
              <em className="text-neon italic" data-id="element-96" data-mp="1vvq373ukfovp">{accent}</em>
              {after}
            </> : title}
        </h1>
        <div className="rule-gold mt-7 w-28" data-id="element-97" data-mp="2pj2xt636bt8f" />
        {subtitle && <p className="mt-7 text-lg font-light leading-relaxed text-neutral-200" data-id="element-98" data-mp="2plfm00ziyztx">{subtitle}</p>}
        {note && <p className="mt-4 text-[15px] font-light leading-relaxed text-neutral-400" data-id="element-99" data-mp="2zibpttehaxs5">{note}</p>}
      </motion.div>
    </section>;
}